var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticStyle: { height: "100%", "background-color": "#222" } },
    [
      _c(
        "v-layout",
        { attrs: { xs12: "", column: "", wrap: "", "justify-center": "" } },
        [
          _c(
            "v-flex",
            {
              staticStyle: { "margin-bottom": "15px" },
              attrs: { xs12: "", fluid: "" }
            },
            [
              _c(
                "v-icon",
                { staticStyle: { "font-size": "24px", color: "#bf975f" } },
                [_vm._v("fas fa-user")]
              ),
              _c(
                "span",
                {
                  staticClass: "pl-2 ml-2",
                  staticStyle: {
                    "font-size": "13px",
                    "text-transform": "uppercase",
                    color: "#bf975f"
                  }
                },
                [_vm._v("USER")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", xs12: "" } },
            [
              _c("v-flex", { attrs: { xs3: "" } }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "13px",
                      "text-transform": "uppercase"
                    }
                  },
                  [_vm._v("Type :")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "13px",
                      "text-transform": "uppercase"
                    }
                  },
                  [_vm._v(_vm._s(_vm.selectedType))]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.selectedType === "Verbal"
            ? _c(
                "v-flex",
                [
                  _c(
                    "v-flex",
                    { staticClass: "my-4", attrs: { x12: "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { column: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "mb-4",
                              staticStyle: {
                                "font-size": "15px",
                                "text-transform": "uppercase"
                              }
                            },
                            [
                              _vm._v(
                                "\n                Anticipated User Response\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-layout",
                                {
                                  staticStyle: { float: "left" },
                                  attrs: { row: "", wrap: "" }
                                },
                                _vm._l(_vm.keywords, function(keyword, i) {
                                  return _c(
                                    "v-flex",
                                    { key: i, attrs: { shrink: "" } },
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          staticStyle: { float: "left" },
                                          attrs: {
                                            outline: "",
                                            "text-color":
                                              "rgb(255,255,255,0.5)",
                                            close: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeKeyword(keyword)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(keyword.value) +
                                              "\n                      "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            float: "bottom",
                                            color: "#9FA8DA"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.similarityScores[i])
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                              _vm._v(" "),
                              !_vm.keywords.length
                                ? _c(
                                    "v-flex",
                                    {
                                      staticClass: "pa-3",
                                      staticStyle: {
                                        color: "rgb(255,255,255,0.4)"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Empty\n                "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs7: "" } },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "15px",
                            "text-transform": "uppercase"
                          }
                        },
                        [_vm._v("Add Ancitipated User Responses")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "pr-2 pl-r pt-2",
                            attrs: { dark: "", label: "Keywords" },
                            model: {
                              value: _vm.keywordInput,
                              callback: function($$v) {
                                _vm.keywordInput = $$v
                              },
                              expression: "keywordInput"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            {
                              staticStyle: { float: "bottom" },
                              attrs: { row: "" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "#bf975f",
                                    dark: "",
                                    round: ""
                                  },
                                  on: { click: _vm.addKeyword }
                                },
                                [_vm._v("Add")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "#bf975f",
                                    dark: "",
                                    round: ""
                                  },
                                  on: { click: _vm.enableSynonymDialog }
                                },
                                [_vm._v("Synonym")]
                              ),
                              _vm._v(" "),
                              _vm.simiLoading
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        loading: "",
                                        disabled: "",
                                        color: "#bf975f",
                                        dark: "",
                                        round: ""
                                      },
                                      on: { click: _vm.similarityCheckAll }
                                    },
                                    [_vm._v("Similarity")]
                                  )
                                : _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "#3F51B5",
                                        dark: "",
                                        round: ""
                                      },
                                      on: { click: _vm.similarityCheckAll }
                                    },
                                    [_vm._v("Similarity")]
                                  )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { xs2: "" } })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedType === "Non-Verbal"
            ? _c(
                "v-flex",
                [
                  _c(
                    "v-flex",
                    {
                      staticStyle: {
                        "font-size": "13px",
                        "text-transform": "uppercase"
                      }
                    },
                    [
                      _vm._v(
                        "\n            Conditional Combinations\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.conditions, function(condition, i) {
                    return _c(
                      "v-flex",
                      { key: i },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "mt-3",
                            staticStyle: {
                              "font-size": "13px",
                              "text-transform": "uppercase"
                            }
                          },
                          [
                            _vm._v(
                              "\n               Condition " +
                                _vm._s(i + 1) +
                                "\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("user-panel-condition", {
                          attrs: {
                            condition: condition,
                            userConditionItems: _vm.editor.userConditionItems,
                            visualItems: _vm.visualItems
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { dark: "", depressed: "" },
                      on: { click: _vm.addCondition }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [_vm._v("add")]),
                      _vm._v("\n              Add Condition\n            ")
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-91326b0c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91326b0c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/story-edit-view/userPanel.vue
// module id = null
// module chunks = 